import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

///FULL EXAMPLE:	"components.trigger-editor.action.agent-action.summary.[action.code].<*,:>": "הורדה למערכת חיצונית* {{code}}",

type TranslatorPipeOptions = {
	defaultForEmpty?: string;
};

@Pipe({
	name: 'translator',
	standalone: true,
	pure: false,
})
export class TranslatorPipe implements PipeTransform {
	private options: TranslatorPipeOptions = {};
	private readonly translatePipe: TranslatePipe;

	constructor(translate: TranslateService, _ref: ChangeDetectorRef) {
		this.translatePipe = new TranslatePipe(translate, _ref);
	}

	transform(query: string, source: object, options?: TranslatorPipeOptions): string {
		this.options = options || {};
		try {
			if (query && source) {
				const {pathToPlaceholder, toReplace} = this._extractFeatures(query);
				if (pathToPlaceholder || toReplace) {
					let translationResult = query;
					if (pathToPlaceholder) {
						translationResult = this._exec_path_to_placeholder(query, source, pathToPlaceholder);
					}
					if (toReplace) {
						translationResult = this._exec_replace_strings(translationResult, toReplace.substring, toReplace.replaceValue);
					}
					return this._transform_results(translationResult, this.options.defaultForEmpty);
				}
			}
		} catch (e) {
			/** Istanbul */
			return this.translatePipe.transform(query);
		}
		return this._transform_results(this.translatePipe.transform(query), this.options.defaultForEmpty);
	}

	private _transform_results(query: string, defaultForEmpty?: string): string {
		try {
			if (defaultForEmpty === undefined) return query;
			// if the result contains '{{any_key}}'	it means that the translation is not found => replace the {{any_key}} with the default value
			return query.replace(/{{[^{}]+}}/g, defaultForEmpty || '');
		} catch (e) {
			/** Istanbul */
			return query;
		}
	}

	private _exec_replace_strings(query: string, substringToReplace: string, replaceValue: string): string {
		query = this.translatePipe.transform(query);
		return query.replace(substringToReplace, replaceValue);
	}

	private _exec_path_to_placeholder(query: string, source: object, path_to_placholder: string[]): string {
		let currentValue = source;
		path_to_placholder.forEach(key => {
			if (currentValue) {
				currentValue = currentValue[key];
			}
		});
		const translatedValue = this.translatePipe.transform(query, {[path_to_placholder[path_to_placholder.length - 1]]: currentValue});
		return translatedValue;
	}

	// check if there is '<X:Y>' in the query
	private _extractFeatures(query: string): {pathToPlaceholder?: string[] | undefined; toReplace?: {substring: string; replaceValue: string} | undefined} {
		const results: {pathToPlaceholder?: string[] | undefined; toReplace?: {substring: string; replaceValue: string} | undefined} = {};

		// Feature 1: check if there is path to placeholder in the translations key
		const match = query.match(/\[([^[\]]+)\]/g)?.[0];
		if (match) {
			// remove the brackets from the match, then split by '.' to get the path segments
			results.pathToPlaceholder = match.slice(1, -1).split('.');
		}

		// Feature 2: check if there is a substring to replace in the translations key
		const toReplaceMatch = query.match(/<([^,]+),([^>]+)>/);
		if (toReplaceMatch) {
			results.toReplace = {
				substring: toReplaceMatch[1],
				replaceValue: toReplaceMatch[2],
			};
		}

		return results;
	}
}
